$(function() {
	//accordion
	$('.vioserum2023_point_box01_btn_link').click(function(){
        $(this).fadeOut(50);
		$('.vioserum2023_point_box01_detail').delay(50).slideDown(400);	

	});
    
	//accordion
	$('.vioserum2023_faq_question').click(function(){
		$(this).toggleClass('open');
		$(this).next('.vioserum2023_faq_answer').slideToggle(300);
	});
    
    //slide
        $('#vioserum2023_voices_box01_list').slick({
            rows: 1,
            slidesToShow: 3,
            speed: 600,
            infinite:false,
            arrows:false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                }
            }]
        });
    //slide
        $('#vioserum2023_others_list').slick({
            rows: 1,
            slidesToShow: 3,
            speed: 600,
            infinite:false,
            arrows:false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }]
        });



//graph
Chart.plugins.register({
    afterDatasetsDraw: function (chart, easing) {
        var ctx = chart.ctx;

        chart.data.datasets.forEach(function (dataset, i) {
            var meta = chart.getDatasetMeta(i);

        });
    }
});
$('#vioserum2023_voices').one('inview', function() {
$('.vioserum2023_voices_box01_item01').addClass('is-show');
$('.vioserum2023_voices_box01_item02').delay(300).queue(function(){$(this).addClass('is-show').dequeue();});
$('.vioserum2023_voices_box01_item03').delay(600).queue(function(){$(this).addClass('is-show').dequeue();});
$('.vioserum2023_voices_box01_notes').delay(900).queue(function(){$(this).addClass('is-show').dequeue();});
$('.vioserum2023_purchase').delay(1200).queue(function(){$(this).addClass('is-show').dequeue();});
    
var ctx01 = document.getElementById('vioserum2023_voices_box01_chart01');
var chart01 = new Chart(ctx01,{
type:'doughnut',
data:{
	datasets:[{
			backgroundColor:['#006cd6','#7db7fa'],
			data:['96','4'],
            borderWidth: 0
		}]
},
options:{
	maintainAspectRatio: false,
    cutoutPercentage:87,
}
});

setTimeout(function (event) {
var ctx02 = document.getElementById('vioserum2023_voices_box01_chart02');
var chart02 = new Chart(ctx02,{
type:'doughnut',
data:{
	datasets:[{
			backgroundColor:['#006cd6','#7db7fa'],
			data:['99.75','0.25'],
            borderWidth: 0
		}]
},
options:{
	maintainAspectRatio: false,
    cutoutPercentage:87,
}
});
}, 600, event);

setTimeout(function (event) {
var ctx03 = document.getElementById('vioserum2023_voices_box01_chart03');
var chart03 = new Chart(ctx03,{
type:'doughnut',
data:{
	datasets:[{
			backgroundColor:['#006cd6','#7db7fa'],
			data:['96','4'],
            borderWidth: 0
		}]
},
options:{
	maintainAspectRatio: false,
    cutoutPercentage:87,
}
});
}, 900, event);
});



    
//jrumble
$('.vioserum2023_hero_ttl_primary02').jrumble({x: 0.3,y: 0.3, rotation: 0.3, speed: 4});
    
//fade
$('#vioserum2023_hero').one('inview', function () {
        $('.vioserum2023_hero_ttl_primary').addClass('is-show');
		setTimeout('$(".vioserum2023_hero_ttl_primary02").trigger("startRumble");', 900); 
		setTimeout('$(".vioserum2023_hero_ttl_primary02").trigger("stopRumble");', 2000);
        $('.vioserum2023_hero_ttl_secondary').delay(300).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_hero_img01').delay(600).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_hero_img02').delay(900).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_hero_img03').delay(1200).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_hero_img04').delay(1500).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_hero_ttl_tertiary').delay(1800).queue(function(){$(this).addClass('is-show').dequeue();});
  });
    
//fade
$('#vioserum2023_lead_box').one('inview', function () {
  var windowWidth = $(window).width();
    if(windowWidth >= 768){
        $('.vioserum2023_lead_item01').addClass('is-show');
        $('.vioserum2023_lead_item04').delay(300).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_lead_item02').delay(600).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_lead_item05').delay(900).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_lead_item03').delay(1200).queue(function(){$(this).addClass('is-show').dequeue();});  
    }else if(windowWidth < 767){
        $('.vioserum2023_lead_item01').addClass('is-show');
        $('.vioserum2023_lead_item02').delay(300).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_lead_item03').delay(600).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_lead_item04').delay(900).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_lead_item05').delay(1200).queue(function(){$(this).addClass('is-show').dequeue();});  

    }
  });
    
//fade
$('#vioserum2023_recommend').one('inview', function () {
        $('.vioserum2023_recommend_shoulder_line').addClass('is-show');
        $('.vioserum2023_recommend_ttl_primary').addClass('is-show');
        $('.vioserum2023_recommend_box01').delay(300).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_recommend_box02').delay(600).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_recommend_box02_item01').delay(900).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_recommend_box02_item02').delay(1200).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_recommend_box02_item03').delay(1500).queue(function(){$(this).addClass('is-show').dequeue();});
  });
//fade
$('#vioserum2023_feature').one('inview', function () {
        $('.vioserum2023_feature_box01').addClass('is-show');
        $('.vioserum2023_feature_box01_img01').delay(300).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_feature_box01_img02').delay(600).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_feature_box02').delay(900).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_feature_box03').delay(1200).queue(function(){$(this).addClass('is-show').dequeue();});

  });
//fade
$('#vioserum2023_point').one('inview', function () {
        $('.vioserum2023_point_ttl_primary').addClass('is-show');
        $('.vioserum2023_point_lead').delay(300).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_point_box01').delay(600).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_point_box02_item01').delay(900).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_point_box02_item02').delay(1200).queue(function(){$(this).addClass('is-show').dequeue();});
  });
//fade
$('#vioserum2023_howto').one('inview', function () {
        $('.vioserum2023_howto_box01_item01').addClass('is-show');
        $('.vioserum2023_howto_box01_balloon').delay(300).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_howto_box01_item02').delay(600).queue(function(){$(this).addClass('is-show').dequeue();});
        $('.vioserum2023_howto_box02').delay(900).queue(function(){$(this).addClass('is-show').dequeue();});
  });
//fade
$('#vioserum2023_faq').one('inview', function () {
        $('.vioserum2023_faq_list').addClass('is-show');
  });
//fade
$('#vioserum2023_conclusion').one('inview', function () {
        $('.vioserum2023_purchase').addClass('is-show');
        $('.vioserum2023_conclusion_notes').delay(300).queue(function(){$(this).addClass('is-show').dequeue();});
  });
//fade
$('#vioserum2023_others').one('inview', function () {
        $('.vioserum2023_others_list').addClass('is-show');
  });
});   

